import { render, staticRenderFns } from "./Uppgifter.vue?vue&type=template&id=e29142e4&"
import script from "./Uppgifter.vue?vue&type=script&lang=js&"
export * from "./Uppgifter.vue?vue&type=script&lang=js&"
import style0 from "./Uppgifter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports